import { Box, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectAppSettings } from 'store/reducers/appSettings/appSettings.slice';
import { Phone } from '@manulife/mux-cds-icons';
import { messages } from 'constants/common';

const backupContact = '800-225-5291';
const backupContactEmergency = '888-999-4307';
const backupContactHours =
  'Monday through Thursday, from 8:00 A.M. to 7:00 P.M. and Friday, 8:00 A.M. to 6:00 P.M., ET.';
const backupContactEmergencyHours =
  'Monday through Friday, from 9:00 A.M. to 5:00 P.M., ET.';

const DTCInfo = () => {
  const { contact, contactEmergency, contactHours, contactEmergencyHours } =
    useSelector(selectAppSettings);

  // Fallback to backup values if the values are null or empty strings
  const resolvedContact = contact || backupContact;
  const resolvedContactEmergency = contactEmergency || backupContactEmergency;
  const resolvedContactHours = contactHours || backupContactHours;
  const resolvedContactEmergencyHours =
    contactEmergencyHours || backupContactEmergencyHours;

  return (
    <Box>
      <Box sx={styles.section}>
        <Typography sx={styles.header}>
          {messages.NEED_ASSISTANCE_MESSAGE}
        </Typography>
      </Box>
      <Box sx={styles.section}>
        <Typography sx={styles.header}>{messages.CONTACT_MESSAGE}:</Typography>
        <Box sx={styles.subSection}>
          <Typography sx={styles.boldText}>
            John Hancock Investments IRA account support and registration
            support
          </Typography>
          <Typography sx={styles.text}>{resolvedContactHours}</Typography>
          <Typography sx={styles.text}>
            <Phone style={styles.contactIcon} />
            <strong>
              <u>{resolvedContact}</u>
            </strong>
          </Typography>
        </Box>
        <Box sx={styles.subSection}>
          <Typography sx={styles.boldText}>
            Emergency savings account support and registration support
          </Typography>
          <Typography sx={styles.text}>
            {resolvedContactEmergencyHours}
          </Typography>
          <Typography sx={styles.text}>
            <Phone style={styles.contactIcon} />
            <strong>
              <u>{resolvedContactEmergency}</u>
            </strong>
          </Typography>
        </Box>
      </Box>
      <hr style={styles.separator} />
      <Typography sx={styles.subContent}>
        <strong>{messages.PLEASE_NOTE_MESSAGE} </strong>
        {messages.INACTIVE_SESSION_MESSAGE}
      </Typography>
    </Box>
  );
};

const styles = {
  section: {
    marginBottom: '40px',
  },
  subSection: {
    marginTop: '24px',
  },
  header: {
    fontSize: '20px',
    fontWeight: '600',
    textAlign: 'left',
    lineHeight: '28px',
  },
  separator: {
    marginTop: '30px',
    marginBottom: '30px',
  },
  subContent: {
    fontSize: '12px',
  },
  boldText: {
    fontSize: '14px',
    fontWeight: '600',
    lineHeight: '20px',
  },
  text: {
    fontSize: '12px',
    fontWeight: '400',
    lineHeight: '16px',
    margin: '8px 0',
  },
  contactIcon: {
    height: '16px',
    width: '16px',
    marginRight: '8px',
  },
};

export default DTCInfo;
